import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import isEmpty from "lodash/isEmpty";
import { UpdateVedtakerFerdigBehandlet } from "../../actions/klager/vedtakAction";
import { handleChange as handleChangeAction } from "../../actions/handleChangeAction";
import { IsValidated } from "../../utils/validationUtils";

const rules = {
  vedtakskode: "required",
};

export default function FerdigBehandlerVedtakerContainer() {
  const dispatch = useDispatch();
  const klageId = useSelector((state) =>
    state.klageDetail && state.klageDetail.id ? state.klageDetail.id : "",
  );
  const vedtaker = useSelector((state) => state.vedtaker);
  const klageVedtakerForm = useSelector(
    (state) => state.forms && state.forms.klageVedtakerForm,
  );

  const [showFerdigbehandleVedtakSpinner, setShowFerdigbehandleVedtakSpinner] =
    useState(false);

  const isValid = () => {
    let isValidArray = [];
    for (const [key, value] of Object.entries({ ...klageVedtakerForm })) {
      const { isValid: valid, validationError } = IsValidated(value, rules);
      isValidArray.push(valid);
      dispatch(
        handleChangeAction("KLAGE_VEDTAKER_FORM", key, {
          vedtakskode: value.vedtakskode,
          belop: value.belop,
          validationError,
        }),
      );
    }
    return isValidArray.every((v) => v === true);
  };

  const ferdigBehandleVedtaker = async () => {
    if (isValid()) {
      setShowFerdigbehandleVedtakSpinner(true);
      await dispatch(UpdateVedtakerFerdigBehandlet(klageId));
      setShowFerdigbehandleVedtakSpinner(false);
    }
  };

  const buttonIsDesabled = () => {
    return (
      !isEmpty(vedtaker) &&
      Object.values(vedtaker).every((vedtak) => vedtak.vedtaksDato != null)
    );
  };

  return (
    <button
      className="btn btn-bym-positive btn-bym-standard"
      onClick={ferdigBehandleVedtaker}
      disabled={buttonIsDesabled()}
    >
      {showFerdigbehandleVedtakSpinner ? "Behandler…" : "Ferdigbehandle vedtak"}
    </button>
  );
}
